import { useState } from 'react';
import type { TaskDetails } from '../../../../services/scraper';
import { isDeletableStatus } from '../utils';

export const useScrapingSelection = () => {
  const [selectedTaskIds, setSelectedTaskIds] = useState<string[]>([]);
  const [isSelectAllMode, setIsSelectAllMode] = useState(false);

  const handleSelectTask = (taskId: string, taskStatus: string) => {
    if (!isDeletableStatus(taskStatus)) {
      return;
    }

    setIsSelectAllMode(false);
    setSelectedTaskIds(prev =>
      prev.includes(taskId)
        ? prev.filter(id => id !== taskId)
        : [...prev, taskId]
    );
  };

  const handleSelectAll = (tasks: TaskDetails[]) => {
    const deletableTaskIds = tasks
      .filter(task => isDeletableStatus(task.status))
      .map(task => task.id)
      .filter((id): id is string => Boolean(id));

    if (selectedTaskIds.length === deletableTaskIds.length) {
      setSelectedTaskIds([]);
      setIsSelectAllMode(false);
    } else {
      setSelectedTaskIds(deletableTaskIds);
      setIsSelectAllMode(true);
    }
  };

  const clearSelection = () => {
    setSelectedTaskIds([]);
    setIsSelectAllMode(false);
  };

  return {
    selectedTaskIds,
    isSelectAllMode,
    handleSelectTask,
    handleSelectAll,
    clearSelection,
  };
};
